/* eslint-disable @typescript-eslint/no-explicit-any */
import { Address } from './Address'

export enum CustomerKind {
  Person = 'person',
  Company = 'company'
}

export interface CustomerDefaultAddress {
  id: string;
  billingAddress: Address;
  deliveryAddress?: Address;
  billingIsDeliveryAddress: boolean;
}

export interface Contact {
  id: string;
  title: string;
  lastName: string;
  firstName: string;
  salutation: string;
  email: string;
  phone: string;
}

export interface CustomerData {
  city: string;
  kind: CustomerKind,
  name: string;
  number: string|number;
  street: string;
  contact?: Contact;
  country: string;
  zipCode: string;
  vatNumber: string;
  countryIso: string;
  companyName: string;
  companyNameAffix: string;
  netPriceAsDefault: boolean;
  notes?: string;
  notesAlert?: boolean;
  email?: string
  buyerReference?: string;
  customerOwnSupplierNumber?: string;
  customerReferenceNumber?: string;
}

export interface Customer {
  id: string;
  addressId: string;
  category?: any;
  discount: number;
  number: number;
  kind: CustomerKind;
  salutation: string;
  title: string;
  firstName: string;
  lastName: string;
  companyName: string;
  companyNameAffix: string;
  name: string;
  email?: any;
  fax?: any;
  mobile?: any;
  phone1?: any;
  phone2?: any;
  website?: any;
  vatNumber?: any;
  netPriceAsDefault: boolean;
  notes: string;
  notesAlert: boolean;
  deliveryConditionId: string;
  payConditionId: string;
  contactPersons: any[];
  balance?: any;
  deletedAt?: any;
  customerDefaultAddress: CustomerDefaultAddress;
  externalReferences: any[];
  addresses: any[];
  tags: any[];
  accountNo?: any;
  contact: any;

  city: string;
  zipCode: string;
  street: string;
  countryIso: string;
  buyerReference?: string;
  customerOwnSupplierNumber?: string;
  customerReferenceNumber?: string;
}
